import { useMemo } from "react";
import { number, object, bool } from "prop-types";
import { observer } from "mobx-react";
import { MinAvgMaxKeys } from "@repo/utils";
import { useEstimateStructure } from "@tools";
import { BufferTooltipContent } from "./components";

export const BreakdownWorkloadBufferTooltip = observer(({
  element,
  cleanValue,
  workTypeId,
  isMax
}) => {
  const structure = useEstimateStructure();
  const { maxValuesAsBuffer } = structure.settings;
  
  const displayTwoValues = element.displayWorkTypeTwoValues[workTypeId];
  
  const valueKey = useMemo(() => {
    if(maxValuesAsBuffer)
      return MinAvgMaxKeys.AVG;
    if(isMax)
      return MinAvgMaxKeys.MAX;
    
    return displayTwoValues ? MinAvgMaxKeys.MIN : MinAvgMaxKeys.AVG;
  }, [isMax, displayTwoValues, maxValuesAsBuffer])
  
  const bufferedValues = element.getBufferedValue(workTypeId, valueKey);
  
  return <BufferTooltipContent
    cleanValue={cleanValue}
    bufferedValues={bufferedValues}
  />
});

BreakdownWorkloadBufferTooltip.propTypes = {
  element: object.isRequired,
  cleanValue: number.isRequired,
  workTypeId: number.isRequired,
  isMax: bool,
}